import { useDispatch, useSelector } from "react-redux";
import PageContainer from "../components/PageContainer";
import PageTitle from "../components/PageTitle";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { getUnlogged } from "../redux/userSlice";
import { useEffect, useRef, useState } from "react";
import UserRequestCard from "../components/booking/UserRequestCard";
import CustomHr from "../components/CustomHr";
import CardContainer from "../components/CardContainer";
import ActivityCard from "../components/ActivityCard";
import Loader from '../components/Loader';
import Error from '../components/Error';
import { setBacklink } from "../redux/backlinkSlice.js";
import { useTranslation } from 'react-i18next';
import ProfileAccordion from "../components/AccordionWrapper";
import AccordionWrapper from "../components/AccordionWrapper";
import { CreditCard, Truck, User, WalletCards } from "lucide-react";

const ProfilePage = () => {

    const { t } = useTranslation();
    const { id, user, requests, favourites, isUserPurchaseAvailable, isUserShopOrderAvailable } = useSelector(state => state.user);
    const token = localStorage.getItem('ticino-wild-token');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const setLogout = () => {
        localStorage.removeItem('ticino-wild-token');
        dispatch(getUnlogged());
        navigate("/");
    }

    // Recupero l'email in backend
    const [email, setEmail] = useState(null);
    const [emailFetchStatus, setEmailFetchStatus] = useState('idle');
    const [emailError, setEmailError] = useState(null);
    const getEmail = async () => {
        setEmailFetchStatus('loading');
        const url = `${process.env.REACT_APP_SERVER_BASE_URL}/users/get-email/${id}`;
        const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
        const options = { method: 'GET', headers };
        try {
            const response = await fetch(url, options);
            if (response.ok) {
                const result = await response.json();
                setEmail(result.payload);
                setEmailFetchStatus('succeeded');
            } else {
                const error = await response.json();
                throw error;
            }
        } catch (error) {
            setEmailError(error.message || "Errore nel riceve l'indirizzo email.");
            setEmailFetchStatus('failed');
        }
    }
    useEffect(() => {
        if (id) getEmail();
    }, [id])

    // Mando favourites in backend per riceverne le attività corrispondenti
    const [favouritesData, setFavouritesData] = useState([]);
    const [isFavouritesLoading, setIsFavouritesLoading] = useState(false);
    const [favouritesError, setFavouritesError] = useState(null);
    useEffect(() => {
        if (favourites) {
            if (favourites.length > 0) {
                favouritesDataFetch();
            }
        }
    }, [favourites])

    const favouritesDataFetch = async () => {
        setIsFavouritesLoading(true);
        try {
            const url = `${process.env.REACT_APP_SERVER_BASE_URL}/activities/get-user-activities-by-id-array`;
            const headers = {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            };
            const options = {
                method: 'POST',
                headers,
                body: JSON.stringify({ favouritesIdArray: favourites })
            };
            const response = await fetch(url, options);
            if (response.ok) {
                const result = await response.json();
                setFavouritesData(result.payload);
                setIsFavouritesLoading(false);
            } else {
                const error = await response.json();
                throw error;
            }
        } catch (error) {
            console.error(error.message || "Errore durante la richiesta Favourites.");
            setFavouritesError(error);
            setIsFavouritesLoading(false);
        }
    }

    // Verifico se sono impostati i dati d'acquisto dell'utente. In caso positivo eseguo la chiamata per riceverli
    const [purchaseData, setPurchaseData] = useState(null);
    const [purchaseDataFetchStatus, setPurchaseDataFetchStatus] = useState('idle');
    const [purchaseDataError, setPurchaseDataError] = useState(null);
    const getPurchaseData = async () => {
        setPurchaseDataFetchStatus('loading');
        const url = `${process.env.REACT_APP_SERVER_BASE_URL}/users/get-purchase-data/${id}`;
        const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
        const options = { method: 'GET', headers };
        try {
            const response = await fetch(url, options);
            if (response.ok) {
                const result = await response.json();
                setPurchaseData(result.payload);
                setPurchaseDataFetchStatus('succeeded');
            } else {
                const error = await response.json();
                throw error
            }
        } catch (error) {
            setPurchaseDataError(error.message || "Errore nel ricevere i dati d'acquisto.");
            setPurchaseDataFetchStatus('failed');
        }
    }
    useEffect(() => {
        if (isUserPurchaseAvailable) getPurchaseData();
    }, [isUserPurchaseAvailable])
    // Gestisco click sul button di impostazione dati d'acquisto utente
    const handleSetDataClick = () => {
        dispatch(setBacklink("/my-profile"));
        navigate("/set-user-data");
    }

    // Verifico se sono impostati i dati di spedizione dell'utente. In caso positivo eseguo la chiamata per riceverli
    const [shippingData, setShippingData] = useState(null);
    const [shippingDataFetchStatus, setShippingDataFetchStatus] = useState('idle');
    const [shippingDataError, setShippingDataError] = useState(null);
    const getShippingData = async () => {
        setShippingDataFetchStatus('loading');
        const url = `${process.env.REACT_APP_SERVER_BASE_URL}/users/get-shipping-data/${id}`;
        const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
        const options = { method: 'GET', headers };
        try {
            const response = await fetch(url, options);
            if (response.ok) {
                const result = await response.json();
                setShippingData(result.payload);
                setShippingDataFetchStatus('succeeded');
            } else {
                const error = await response.json();
                console.log('error: ', error)
                throw error
            }
        } catch (error) {
            setShippingDataError(error.message || "Errore nel ricevere i dati di spedizione.");
            setShippingDataFetchStatus('failed');
        }
    }
    useEffect(() => {
        if (isUserShopOrderAvailable) getShippingData();
    }, [isUserShopOrderAvailable])
    // Gestisco click sul button di impostazione dati di spedizione utente
    const handleSetShippingDataClick = () => {
        dispatch(setBacklink("/my-profile"));
        navigate("/set-shipping-data");
    }

    // Richiedo i dati (nome) delle attività in request
    const [requestActivitiesData, setRequestActivitiesData] = useState(null);
    const [requestActivitiesDataStatus, setRequestActivitiesDataStatus] = useState('idle');
    const [requestActivitiesDataError, setRequestActivitiesDataError] = useState(null);
    const getRequestActivities = async (array) => {
        setRequestActivitiesDataStatus('loading');
        try {
            const url = `${process.env.REACT_APP_SERVER_BASE_URL}/activities/get-activities-data-requests`;
            const headers = {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            };
            const options = {
                method: 'POST',
                headers,
                body: JSON.stringify({ requestsArray: array })
            };
            const response = await fetch(url, options);
            if (response.ok) {
                const result = await response.json();
                setRequestActivitiesData(result.payload);
                setRequestActivitiesDataStatus('succeeded');
            } else {
                const error = await response.json();
                throw error;
            }
        } catch (error) {
            console.error(error.message || "Errore durante la richiesta Requests.");
            setRequestActivitiesDataError(error);
            setRequestActivitiesDataStatus('failed');
        }
    }
    useEffect(() => {
        if (requests) {
            // Ricavo la lista di id delle requests;
            const requestsIdArray = requests.map(element => {
                return { requestId: element._id, status: element.status, requestDate: element.createdAt, activityId: element.activityId }
            })
            getRequestActivities(requestsIdArray);
        }
    }, [requests])
    return (
        <PageContainer desktopItems="center">
            <PageTitle backLink="/" title={t('ProfilePage.title')} />


            {/* Accordion group */}
            <div className="flex flex-col gap-4 w-full max-w-4xl">
                {/* Basic info */}
                <AccordionWrapper
                    title={t('ProfilePage.userInfo')}
                    icon={<User color="#225424" />}
                >
                    <div className="flex flex-col gap-4">
                        <div className="flex flex-col lg:flex-row gap-1">
                            <label htmlFor="id" className="text-sm text-[#225424]">{t('ProfilePage.userId')}</label>
                            <div>{id}</div>
                        </div>
                        <div className="flex flex-col lg:flex-row gap-1">
                            <label htmlFor="user" className="text-sm text-[#225424]">{t('ProfilePage.userName')}</label>
                            <div>{user}</div>
                        </div>
                        <div className="flex flex-col lg:flex-row lg:items-center gap-1">
                            <label htmlFor="user" className="text-sm text-[#225424]">{t('ProfilePage.email')}</label>
                            {
                                emailFetchStatus === 'loading' &&
                                <Loader />
                            }
                            {
                                emailFetchStatus === 'failed' &&
                                <Error text={emailError} message="Ricarica la pagina." />
                            }
                            {
                                emailFetchStatus === 'succeeded' &&
                                <div>{email}</div>
                            }
                        </div>
                    </div>
                </AccordionWrapper>

                {/* Dati d'acquisto utente */}
                <AccordionWrapper
                    title={t('ProfilePage.yourPurchaseData')}
                    icon={<CreditCard color="#225424" />}
                >
                    <div className="flex flex-col">
                        {
                            isUserPurchaseAvailable &&
                            <div className="flex flex-col gap-4">
                                <h4 className="text-neutral-400">{t('ProfilePage.yourPurchaseData')}</h4>
                                <div className="flex flex-col lg:flex-row gap-1">
                                    <label htmlFor="id" className="text-sm text-[#225424]">{t('ProfilePage.firstName')}</label>
                                    <div>{purchaseData?.firstName}</div>
                                </div>
                                <div className="flex flex-col lg:flex-row gap-1">
                                    <label htmlFor="user" className="text-sm text-[#225424]">{t('ProfilePage.lastName')}</label>
                                    <div>{purchaseData?.lastName}</div>
                                </div>
                                <div className="flex flex-col lg:flex-row gap-1">
                                    <label htmlFor="user" className="text-sm text-[#225424]">{t('ProfilePage.phoneNumber')}</label>
                                    <div>{purchaseData?.phoneNumber}</div>
                                </div>
                                <div className="flex flex-col lg:flex-row gap-1">
                                    <label htmlFor="user" className="text-sm text-[#225424]">{t('ProfilePage.birthdate')}</label>
                                    <div>{purchaseData?.birthdate}</div>
                                </div>
                            </div>
                        }

                        {
                            !isUserPurchaseAvailable &&
                            <div className="flex flex-col gap-4">
                                <h3>{t('ProfilePage.purchaseDataNotSetYet')}</h3>
                                <p>{t('ProfilePage.setYourData')}</p>
                            </div>
                        }
                        <button className='primary mt-4 w-fit' onClick={handleSetDataClick}>
                            {isUserPurchaseAvailable ? `${t('ProfilePage.editDataButton')}` : `${t('ProfilePage.addDataButton')}`}
                        </button>
                    </div>
                </AccordionWrapper>

                {/* Dati di spedizione utente */}
                <AccordionWrapper
                    title={t('ProfilePage.yourShippingData')}
                    icon={<Truck color="#225424" />}
                >
                    <div className="flex flex-col">
                        {
                            isUserShopOrderAvailable &&
                            <div className="flex flex-col gap-4">
                                <h4 className="text-neutral-400">{t('ProfilePage.yourShippingData')}</h4>
                                <div className="flex flex-col lg:flex-row gap-1">
                                    <label htmlFor="id" className="text-sm text-[#225424]">{t('ProfilePage.country')}</label>
                                    <div>{shippingData?.country}</div>
                                </div>
                                <div className="flex flex-col lg:flex-row gap-1">
                                    <label htmlFor="user" className="text-sm text-[#225424]">{t('ProfilePage.city')}</label>
                                    <div>{shippingData?.city}</div>
                                </div>
                                <div className="flex flex-col lg:flex-row gap-1">
                                    <label htmlFor="user" className="text-sm text-[#225424]">{t('ProfilePage.postalCode')}</label>
                                    <div>{shippingData?.postalCode}</div>
                                </div>
                                <div className="flex flex-col lg:flex-row gap-1">
                                    <label htmlFor="user" className="text-sm text-[#225424]">{t('ProfilePage.address')}</label>
                                    <div>{shippingData?.address}</div>
                                </div>
                            </div>
                        }

                        {
                            !isUserShopOrderAvailable &&
                            <div className="flex flex-col gap-4">
                                <h3>{t('ProfilePage.shippingDataNotSetYet')}</h3>
                                <p>{t('ProfilePage.setYourShippingData')}</p>
                            </div>
                        }
                        <button className='primary mt-4 w-fit' onClick={handleSetShippingDataClick}>
                            {isUserShopOrderAvailable ? `${t('ProfilePage.editShippingDataButton')}` : `${t('ProfilePage.addShippingDataButton')}`}
                        </button>
                    </div>
                </AccordionWrapper>

                {/* Le tue attività prenotate */}
                <AccordionWrapper
                    title={t('ProfilePage.yourRequests')}
                    icon={<WalletCards color="#225424" />}
                >
                    <div className="flex flex-col gap-2">
                        {
                            requestActivitiesData && requestActivitiesData.length > 0 && requestActivitiesData.map((element, index) => {
                                return <UserRequestCard key={index} requestData={element} />
                            })
                        }
                    </div>
                </AccordionWrapper>
            </div>


            {/* Le tue attività preferite */}
            {/* <h3 className="mt-8">{t('ProfilePage.yourFavouriteActivities')}</h3>
            <CustomHr /> */}

            {/* CARD CONTAINER */}
            {/* <div className="flex flex-col py-4">
                {
                    favouritesData && !isFavouritesLoading && !favouritesError &&
                    <CardContainer>
                        {
                            favouritesData.length > 0 && favouritesData.map((element, index) => {
                                return <ActivityCard key={index} activityData={element} />
                            })
                        }
                    </CardContainer>
                }
                {
                    isFavouritesLoading &&
                    <Loader />
                }
                {
                    favouritesError && !isFavouritesLoading &&
                    <Error />
                }

            </div> */}



            {/* Logout*/}
            <h4 className="mt-8">{t('ProfilePage.logout')}</h4>
            <CustomHr />

            <button className="secondary w-fit" onClick={setLogout}>{t('ProfilePage.getLogout')}</button>
        </PageContainer>
    )
}

export default ProfilePage;